import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import SegmentByGender from './SegmentByGender'
import SegmentByAgeRange from './SegmentByAgeRange'
import SegmentByFormatAndGender from './SegmentByFormatAndGender'
import SegmentByFormatAndAgeRange from './SegmentByFormatAndAgeRange'

export default function Customers() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/customers/segment_by_gender" component={SegmentByGender} />
				<Route exact path="/customers/segment_by_age_range" component={SegmentByAgeRange} />
				<Route exact path="/customers/segment_by_format_and_gender" component={SegmentByFormatAndGender} />
				<Route exact path="/customers/segment_by_format_and_age_range" component={SegmentByFormatAndAgeRange} />
				
				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}